import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MessageAdministrationComponent } from './component/message-administration.component';
import { DictionaryFieldsModule, MasterDetailModule } from '@sdbn/common';

import { ApplicationClientCommonModule } from '@sdbn/common';

import { DictionaryModule } from '@sdbn/common';
import { CommonTranslationModule } from '@sdbn/common';


@NgModule({
  declarations: [
    MessageAdministrationComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,

    DictionaryModule,
    CommonTranslationModule,
    ApplicationClientCommonModule,
    MasterDetailModule,
    DictionaryFieldsModule
  ],


})
export class MessageAdministrationModule { }

